// semeia// semeia-disable-reexport
import dayjs from "dayjs";

type Year = `${number}${number}${number}${number}`; // Enforces a 4-digit year
type Month = `${number}` | `0${number}`; // Enforces a 2-digit month (01, 02, ..., 12)
type Day = `${number}` | `0${number}`; // Enforces a 2-digit day (01, 02, ..., 31)

/** A full date string formatted as YYYY-MM-DD type */
export type FormattedDay = `${Year}-${Month}-${Day}` & {
  _brand: "FormattedDay";
};

/**
 * Group Items by day based on a date-like property
 *
 * @param items a list of arbitrary items and a property name common to each items representing a date
 * @param key a property name common to each items representing a date
 * @returns a Map with keys of days as "YYYY-MM-DD", and values of grouped items by days
 */
export default function groupByDay<
  Item extends Record<string, any>,
  Key extends keyof Item
>(items: Item[], key: Key): Map<FormattedDay, Item[]> {
  const reducer = (map: Map<FormattedDay, Item[]>, item: Item) => {
    /*
    Get the item's startof day timestamp
    This timestamp will be used as the Map's key to group the items

    We use timestamp instead of a Date or a dayjs object to make sure Map.has
    comparision properly works.

    For example, new Date("2025-01-01") == new Date("2025-01-01") returns false
    */
    const date = dayjs(item[key]).format("YYYY-MM-DD") as FormattedDay;

    // initialize the items array for the timestamp if necessary
    if (!map.has(date)) map.set(date, []);

    // Add the item to the values
    const items = map.get(date) as Item[];
    items.push(item);

    return map;
  };

  return items.reduce(reducer, new Map());
}
